/* ============================================================
   Maison Atelier Premium — recently-viewed.js
   Salva e mostra gli ultimi prodotti visti (localStorage)
   ============================================================ */
(function () {
  'use strict';
  var settings = (window.theme && window.theme.settings) || {};
  var Wishlist = window.theme && window.theme.Wishlist;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var memory = [];
  var storageUnavailable = false;

  var RecentlyViewed = {
    key: 'sav_recently_viewed',
    limit: Math.max(1, Math.min(20, Number(settings.recentlyViewedLimit) || 8)),
    get: function () {
      if (storageUnavailable) return memory.slice();
      try {
        var stored = JSON.parse(localStorage.getItem(this.key));
        memory = Array.isArray(stored) ? stored.filter(function (handle, index) {
          return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle) && stored.indexOf(handle) === index;
        }) : [];
      } catch (e) { storageUnavailable = true; }
      return memory.slice();
    },
    record: function (handle) {
      if (!handle) return;
      var list = this.get().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, this.limit + 1);
      memory = list;
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) { storageUnavailable = true; }
    }
  };
  window.theme = window.theme || {};
  window.theme.RecentlyViewed = RecentlyViewed;

  var pv = document.querySelector('[data-product-handle]');
  if (pv) RecentlyViewed.record(pv.getAttribute('data-product-handle'));

  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var currentHandle = pv ? pv.getAttribute('data-product-handle') : null;
  var handles = RecentlyViewed.get().filter(function (h) { return h !== currentHandle; }).slice(0, RecentlyViewed.limit);
  if (!handles.length) return;

  var grid = section.querySelector('[data-recently-viewed-grid]');
  if (!grid) return;
  Promise.all(handles.map(function (handle) {
    return fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '?view=card')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          return tmp.querySelector('[data-rv-card], .card');
        }
      })
      .catch(function () { return null; });
  })).then(function (cards) {
    cards.forEach(function (card) { if (card) grid.appendChild(card); });
    if (grid.children.length) {
      section.hidden = false;
      if (Wishlist) Wishlist.syncButtons(section);
      document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: section } }));
    }
  });
})();
